import { APIURL } from "../../constantes.js";
import { LoginDTO } from "../DTOS/Login.dto.js";

export class LoginServicio {
    async Login(usuario, password) {
        const respuesta = await fetch(`${APIURL}/login`, {
            body: JSON.stringify({
                usuario,
                password,
            }),
            headers: {
                "Content-Type": "application/json",
            },
            method: "POST",
            mode: "cors",
        }).then((response) => response.json());

        if (respuesta.error) {
            alert(respuesta.error);
            return new LoginDTO();
        }

        const dto = new LoginDTO();
        dto.cargarDTO(respuesta);
        return dto;
    }

}
